import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

const getMatchesLabel = (count) =>
  count === 1 ? "1 partida" : `${count} partidas`;

const CancelMatchesDialog = ({
  open,
  matchesCount,
  loading,
  errorMessage,
  onClose,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={loading ? undefined : onClose}
    fullWidth
    maxWidth="xs"
  >
    <DialogTitle sx={{ fontWeight: 700 }}>Cancelar partidas</DialogTitle>
    <DialogContent>
      <Stack spacing={1.5}>
        <Typography variant="body2" color="text.secondary">
          Tem certeza que deseja cancelar todas as partidas deste grupo?
        </Typography>
        <Alert severity="warning">
          Esta ação cancelará {getMatchesLabel(matchesCount)} deste grupo.
          Partidas canceladas não poderão receber resultados.
        </Alert>
        {errorMessage ? (
          <Alert severity="error">{errorMessage}</Alert>
        ) : null}
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>
        Voltar
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={onConfirm}
        disabled={loading || matchesCount === 0}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {loading ? "Cancelando..." : "Cancelar partidas"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CancelMatchesDialog;
